function e(e, _ref) {
  var t = _ref.value,
    o = _ref.selectionStart,
    i = _ref.selectionEnd;
  void 0 !== t && (e.value = t), void 0 !== o && void 0 !== i && e.setSelectionRange(o, i);
}
export { e as default };